<template>
  <div class="page-content">
    <!-- Header -->
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="items" />
        <h1 class="page-title">Rechercher une vente</h1>
      </div>
    </div>

    <!-- Search input -->
    <v-card flat class="search-card mb-4">
      <v-card-text class="pa-4">
        <v-text-field
          v-model="query"
          placeholder="Entrer le numéro de fiche..."
          outlined
          dense
          hide-details
          prepend-inner-icon="mdi-magnify"
          clearable
          @input="search"
          class="search-input"
          autofocus
        ></v-text-field>
      </v-card-text>
    </v-card>

    <!-- Loading -->
    <PreloaderComponent :enable="enable" />

    <!-- Results -->
    <div v-if="query && query.trim() && enable">
      <v-card flat class="table-card" v-if="results.length > 0">
        <v-card-title class="pb-2 pt-3 px-4">
          <span class="text-body-2 text--secondary">{{ results.length }} résultat{{ results.length > 1 ? 's' : '' }}</span>
        </v-card-title>
        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-left">#</th>
              <th class="text-left">Emplacement</th>
              <th class="text-left">Agent</th>
              <th class="text-left">Client</th>
              <th class="text-right">Montant</th>
              <th class="text-left">Date</th>
              <th class="text-center">Statut</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="sale in results" :key="sale.id" @click="view(sale.id)" class="clickable-row">
              <td class="font-weight-medium">{{ sale.sale_number }}</td>
              <td>{{ sale.store.name }}</td>
              <td>{{ sale.user.full_name }}</td>
              <td>{{ sale.customer.full_name }}</td>
              <td class="text-right font-weight-bold">{{ sale.total | formatNumber }} {{ sale.rate.name }}</td>
              <td class="text-caption">{{ sale.created_at | formatDate }} {{ sale.created_at | formatTime }}</td>
              <td class="text-center">
                <v-chip x-small :color="sale.status ? 'success' : 'error'" dark>
                  {{ sale.status ? 'Actif' : 'Annulé' }}
                </v-chip>
              </td>
              <td style="width: 40px;">
                <v-btn icon x-small>
                  <v-icon small color="primary">mdi-chevron-right</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>

      <!-- No results -->
      <div v-else class="empty-state">
        <v-icon size="48" color="grey lighten-1">mdi-file-search-outline</v-icon>
        <p class="mt-2 text-body-2 text--secondary">
          Aucun résultat pour <strong>"{{ query.toUpperCase() }}"</strong>
        </p>
      </div>
    </div>

    <!-- Initial state -->
    <div v-if="!query || !query.trim()" class="empty-state">
      <v-icon size="48" color="grey lighten-1">mdi-receipt-text-search-outline</v-icon>
      <p class="mt-2 text-body-2 text--secondary">Entrez un numéro de fiche pour rechercher</p>
    </div>
  </div>
</template>

<script>
import PreloaderComponent from '../components/PreloaderComponent.vue'
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'

export default {
  name: 'TicketSearch',
  components: { BreadcrumbComponent, PreloaderComponent },
  data: () => ({
    query: '',
    results: [],
    enable: true,
    items: [
      { text: 'Accueil', disabled: false, href: '/' },
      { text: 'Recherche', disabled: true, href: '#' },
    ],
  }),
  created() {
    // Pré-remplissage depuis un lien (ex. transaction KL Pay → ?q=<numéro fiche>)
    const q = this.$route.query.q
    if (q) {
      this.query = String(q)
      this.search()
    }
  },
  methods: {
    view(id) {
      this.$router.push('/sales/' + id)
    },
    search() {
      const q = (this.query || '').trim().toUpperCase()
      if (q.length > 0) {
        this.enable = false
        var self = this
        this.$axios.get('/sales?orderdesc=created_at&include=user,store,customer,rate&sale_number=' + q)
          .then(function (response) { self.results = response.data; self.enable = true })
          .catch(function () { self.enable = true })
      } else {
        this.results = []
      }
    }
  },
}
</script>

<style scoped>
.search-card {
  border: 1px solid #e8ecf1 !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
  max-width: 600px;
}

.table-card {
  border: 1px solid #e8ecf1 !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
  overflow: hidden;
}

.table-card .v-simple-table thead th {
  font-size: 0.6875rem !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #94a3b8 !important;
  background: transparent !important;
  border-bottom: 1px solid #e8ecf1 !important;
  padding: 8px 16px !important;
}

.table-card .v-simple-table tbody td {
  font-size: 0.8125rem;
  padding: 10px 16px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.table-card .v-simple-table tbody tr:last-child td {
  border-bottom: none !important;
}

.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background: rgba(25, 65, 115, 0.03) !important;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 16px;
  color: #94a3b8;
}
</style>
